<template>
  <v-container>
    <v-card class="pa-4" color="red" v-if="errorMessage">
      <v-card-title>ОШИБКА</v-card-title>
      <v-card-text>{{ errorMessage }}</v-card-text>
    </v-card>
    <v-form ref="form">
      <v-text-field label="Город" v-model="house.city" required/>
      <v-text-field label="Улица" v-model="house.street" required/>
      <v-text-field label="Номер дома" v-model="house.number" required/>
      <v-text-field label="e-Mail управляющей компании" id="house-email-input" v-model="house.email" type="email"/>
      <v-text-field label="День подачи данных" v-model="house.reminderDay" type="number" min="1" max="31" required/>
      <div>
        <v-btn class="mr-4 mb-4" @click="saveHouse">Сохранить</v-btn>
        <v-btn class="mr-4 mb-4" @click="cancelHouse">Отменить</v-btn>
        <v-btn class="mr-4 mb-4" @click="deleteHouse" v-if="house.id != null && house.id.length > 0">Удалить</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: 'HouseEdit',
  props: {
    houseId: String
  },
  data() {
    return {
      errorMessage: null,
      valid: false,
      house: {
        id: null,
        city: null,
        street: null,
        number: null,
        email: null,
        reminderDay: 15
      }
    }
  },
  mounted() {
    const houseId = this.houseId
    console.log(`HouseEdit ${houseId}`)
    if (houseId) {
      this.$http.get(`/house/${houseId}`)
          .then(resp => this.house = resp.data)
          .catch(err => {
            console.error("error!!!", err.response.data)
            this.errorMessage = err.response.data.message
          })
    }
  },
  methods: {
    saveHouse: function () {
      this.$http.post("/house/", this.house)
          .then(() => this.$router.push({name: 'Houses'}))
          .catch(err => {
            console.error("error!!!", err.response.data)
            this.errorMessage = err.response.data.message
          })
    },
    cancelHouse: function() {
      this.$router.push({name: 'Houses'})
    },
    deleteHouse: function () {
      this.$http.delete(`/house/${this.house.id}`)
          .then(() => this.$router.push({name: 'Houses'}))
          .catch(err => {
            console.error("error!!!", err.response.data)
            this.errorMessage = err.response.data.message
          })
    }
  }
}

</script>

<style scoped>

</style>
